import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Sidebar} from 'primereact/sidebar'
import {forwardRef, useImperativeHandle} from 'react'
import TranslateUtils from '../../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../../utils/BlockScrollsUtils'
import useWindowSize from '../../../utils/useWindowSize'
import StyledNote from './StyledNote'

const StyledNoteSideBar = forwardRef((props, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const {translateDatatable} = TranslateUtils()
    const width = useWindowSize()
    const visible = useSignal(false)

    const handleShowForm = () => {
        blockOverflownScroll()
        visible.value = true
    }
    const handleHideForm = () => {
        unblockOverflownScroll()
        visible.value = false
    }
    return (
        <Sidebar
            id="sidebar-advanced-filter"
            className="sidebar-filter"
            visible={visible.value}
            onHide={handleHideForm}
            showCloseIcon={true}
            fullScreen={width <= 600}
            blockScroll
            position="right"
            baseZIndex={122}>
            <div className="py-2 px-1">
                {/* Header */}
                <div className="flex align-items-center">
                    <div className="mr-2">
                        {/* <FileIcon style={{fontSize: '26px'}} /> */}
                    </div>
                    <div className="flex align-items-center">
                        <i className="pi pi-bookmark-fill mr-2"></i>

                        <h3 className="font-bold m-0">Notes</h3>
                    </div>
                </div>
                <div>
                    <p>
                        Take notes on relevant information to monitor and gain a
                        clear understanding of the patient's care and treatment
                        process
                    </p>
                </div>
                <hr />
                {/* Content */}
                <div
                    className="relative"
                    style={{
                        overflowY: 'hidden',
                    }}>
                    <StyledNote />
                </div>
                <hr className="mx-2" />
                {/* Footer */}
                <div className="my-2 mx-2">
                    <Button
                        label={translateDatatable('Close').toUpperCase()}
                        icon="pi pi-times"
                        className="col-12 p-button-lg p-button-outlined font-bold mb-2"
                        onClick={() => {
                            handleHideForm()
                        }}
                    />
                </div>
            </div>
        </Sidebar>
    )
})

export default StyledNoteSideBar
